import Parameter from "./parameter";
import IAppSetting from "../interface/app-setting";
import ParamStorage from "../enum/param-storage";
import AppSetting from "../enum/app-setting";
import ParameterStorage from "../class/parameter-storage";

class AppSettingsInstance {

    public get<T>(key: AppSetting, defaultValue: T | null = null): T | null {
        const item: IAppSetting<T> | null = this.getItem(key) as IAppSetting<T>;
        if (item) {
            return item.value as T;
        }
        return defaultValue;
    }

    public async set<T>(key: AppSetting, value: T): Promise<IAppSetting<T>> {
        const item: IAppSetting<T> | null = this.getItem(key) as IAppSetting<T>;
        if (item) {
            item.value = value;
            return await this.getStore().update(item) as IAppSetting<T>;
        } else {
            return await this.getStore().create({ key: key, value: value }) as IAppSetting<T>;
        }
    }

    private getItem(key: AppSetting): IAppSetting<unknown> | null {
        const settings: IAppSetting<unknown>[] = this.getStore().getAll();
        return settings.find((s: IAppSetting<unknown>) => s.key === key) || null;
    }

    private getStore(): ParameterStorage<IAppSetting<unknown>> {
        return Parameter.get(ParamStorage.AppSettings);
    }

}

const AppSettings = new AppSettingsInstance();

export default AppSettings;